export const DEBUG = (target: any) => {
  return FD[target as keyof typeof FD]
}

export const FD = {
  PCOLLAPSECARD: false,
  DAYSELECT: false,
  PELEMENT: false,
}
